/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsiderStatsSchema } from '../models/InsiderStatsSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsiderStatsService {
    /**
     * Register Match Events
     * @param matchId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static registerMatchEventsInsiderStatsRegisterMatchIdPost(
        matchId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/insider_stats/register/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Insider Visits
     * @param lastXDays
     * @returns InsiderStatsSchema Successful Response
     * @throws ApiError
     */
    public static getInsiderVisitsInsiderStatsGet(
        lastXDays?: (number | null),
    ): CancelablePromise<InsiderStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider_stats/',
            query: {
                'last_x_days': lastXDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
